export default {
  name: "Gift",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 9h-2.85c.53-.84.85-1.84.85-2.8 0-1.09-.42-2.04-1.29-2.91C23.87 2.46 22.81 2 21.7 2c-3.05 0-4.77 2.4-5.7 4.55C15.07 4.4 13.35 2 10.3 2c-1.11 0-2.17.46-3.01 1.29C6.42 4.16 6 5.11 6 6.2c0 .96.32 1.96.85 2.8H4c-1.16 0-2 .84-2 2v4c0 1.16.84 2 2 2v11c0 1.16.84 2 2 2h20c1.16 0 2-.84 2-2V17c1.16 0 2-.84 2-2v-4c0-1.16-.84-2-2-2zm-6.3-5c.57 0 1.14.25 1.59.71.49.49.71.95.71 1.49 0 1.26-.97 2.8-2.1 2.8h-4.65c.5-1.78 1.76-5 4.45-5zM8 6.2c0-.54.22-1 .71-1.49C9.16 4.25 9.73 4 10.3 4c2.68 0 3.95 3.22 4.44 5H10.1C8.97 9 8 7.46 8 6.2zM4 11h11v4H4v-4zm2 6h9v11H6V17zm20 11h-9V17h9v11zm2-13H17v-4h11v4z",
  },
}
